import DTO from './DTO';
import { required } from '../utils/validation';

class ApplicationsDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'id',
        type: String,
        validators: {},
        labelKey: 'application.id',
      },
      {
        name: 'mais_egu_id',
        type: String,
        validators: [required],
        labelKey: 'mais_egu_id',
      },
      {
        name: 'applied_at',
        type: String,
        validators: {},
        labelKey: 'applied_at',
      },
      {
        name: 'apply_method',
        type: String,
        validators: {},
        labelKey: 'apply_method',
      },
      {
        name: 'apply_files',
        type: String,
        validators: [required],
        labelKey: 'media.apply_files',
      },
      {
        name: 'procedure',
        type: String,
        validators: {},
        labelKey: 'procedure',
      },
      {
        name: 'procedures',
        type: String,
        validators: {},
        labelKey: 'procedure',
      },
      {
        name: 'archive_date',
        type: String,
        validators: {},
        labelKey: 'archive_date',
      },
      {
        name: 'is_archive',
        type: Boolean,
        validators: {},
        labelKey: 'is_archive',
      },
      {
        name: 'number',
        type: String,
        validators: {},
        labelKey: 'registry.number',
      },
      {
        name: 'numbers',
        type: String,
        validators: {},
        labelKey: 'registry.number',
      },
      {
        name: 'status',
        type: String,
        validators: {},
        labelKey: 'application.status',
      },
      {
        name: 'statuses',
        type: String,
        validators: {},
        labelKey: 'application.status',
      },
      {
        name: 'consider_apply_date',
        type: String,
        validators: {},
        labelKey: 'consider_apply_date',
      },
      {
        name: 'review_date',
        type: String,
        validators: {},
        labelKey: 'review_date',
      },
      {
        name: 'decision_deadline_date',
        type: String,
        validators: {},
        labelKey: 'decision_deadline_date',
      },
      {
        name: 'document_submission_deadline_date',
        type: String,
        validators: {},
        labelKey: 'document_submission_deadline_date',
      },
      {
        name: 'document_submission_type',
        type: String,
        validators: [required],
        labelKey: 'document_submission_type',
      },
      {
        name: 'procedure_conducting_authority',
        type: String,
        validators: {},
        labelKey: 'procedure_conducting_authority',
      },
      {
        name: 'decision',
        type: String,
        validators: {},
        labelKey: 'decision',
      },
      {
        name: 'decided_at',
        type: String,
        validators: {},
        labelKey: 'decision_date',
      },
      {
        name: 'is_actual',
        type: String,
        validators: {},
        labelKey: 'is_actual',
      },
      {
        name: 'violation_closing_date',
        type: String,
        validators: {},
        labelKey: 'violation_closing_date',
      },
      {
        name: 'notification_violation_date',
        type: String,
        validators: {},
        labelKey: 'notification_violation_date',
      },
      {
        name: 'delivery_method_extracts_from_register',
        type: String,
        validators: [required],
        labelKey: 'delivery_method_extracts_from_register',
      },
      {
        name: 'delivery_method_notification',
        type: String,
        validators: [required],
        labelKey: 'delivery_method_notification',
      },
      {
        name: 'notification_method',
        type: String,
        validators: [required],
        labelKey: 'notification_method',
      },
      {
        name: 'request_response_files',
        type: String,
        validators: {},
        labelKey: 'media.request_response_files',
      },
      {
        name: 'created_at',
        type: String,
        validators: {},
        labelKey: 'application.created_at',
      },
      {
        name: 'updated_at',
        type: String,
        validators: {},
        labelKey: 'application.updated_at',
      },
      {
        name: 'creator_id',
        type: String,
        validators: {},
        labelKey: 'creator_id',
      },
      {
        name: 'executor_id',
        type: String,
        validators: {},
        labelKey: 'executor_id',
      },
      {
        name: 'list_of_documents',
        type: String,
        validators: [],
        labelKey: 'list_of_documents',
      },
      {
        name: 'rejection_reason_ids',
        type: String,
        validators: {},
        labelKey: 'rejection_reason_ids',
      },
      {
        name: 'additional_rejection_reason_id',
        type: String,
        validators: {},
        labelKey: 'additional_rejection_reason_id',
      },
      {
        name: 'processing_time_limits',
        type: String,
        validators: {},
        labelKey: 'processing_time_limits',
      },
      {
        name: 'view_mode',
        type: String,
        validators: {},
        labelKey: 'view_mode',
      },
      {
        name: 'decision',
        type: String,
        validators: [],
        labelKey: 'decision',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return {};
  }
}

export default ApplicationsDTO;
